module.exports = {
  APILOCALURL: "https://localhost:7050/api/",
  APISERVERURL: "https://srivenfsapi.azurewebsites.net/api/",
  APIACTIVATEURL: "https://srivenfsapi.azurewebsites.net/api/",
  LOGINUSER: "home/login",
  REGISTER: "home/register",

  GETUSER: "User",
  GETUSERBYID: "User",
  GETCLIENTBYUSER: "User/GetClient",
  GETSTAFFBYUSER: "User/GetStaff",
  DELETEUSER: "User",
  UPDATEUSERPROFILE: "User/UpdateUserProfile",
  CHANGEPASSWORD: "User/ChangePassword",

  GETIPADDRESSES: "IPAddresses/getipaddresses",
  CREATEIPADDRESS: "IPAddresses/createipaddresses",
  DELETEIPADDRESS: "IPAddresses/deleteipaddresses",

  GETLOGINHISTORY: "LoginHistory/getloginhistories",
  DELETELOGINHISTORY: "LoginHistory/deleteloginhistory",

  GETALLCATEGORIES: "Category/getallcategories",
  GETCATEGORIES: "Category/getcategories",
  CREATECATEGORY: "Category/createcategory",
  UPDATECATEGORY: "Category/updatecategory",
  DELETECATEGORY: "Category/deletecategory",
  GETTOPLEVELCATEGORIES: "Category/gettoPlevelcategories",
  GETBOTTOMLEVELCATEGORIES: "Category/getbottomlevelcategories",

  GETSYSTEMTASK: "SystemTask/getsystemtask",
  CREATESYSTEMTASK: "SystemTask/createsystemtask",
  UPDATESYSTEMTASK: "SystemTask/updatesystemtask",
  DELETESYSTEMTASK: "SystemTask/deletesystemtask",

  GETALLCLIENTS: "Client/getallclients",
  GETALLCLIENTSDATA: "Client/getallclientsdata",
  GETCLIENTS: "Client/getclients",
  CREATECLIENT: "Client/createclient",
  UPDATECLIENT: "Client/updateclient",
  DELETECLIENT: "Client/deleteclient",
  SEARCHCLIENT: "Client/searchclient",
  IMPORTCLIENTS: "Client/importclients",

  GETCLIENTCATEGORIES: "ClientCategory/getclientcategories",
  CREATECLIENTCATEGORY: "ClientCategory/createclientcategory",
  UPDATECLIENTCATEGORY: "ClientCategory/updateclientcategory",
  DELETECLIENTCATEGORY: "ClientCategory/deleteclientcategory",
  GETSERVICESBYCATEGORY: "ClientCategory/getservicesbycategory",

  GETALLDESIGNATIONS: "Designation/getalldesignations",
  GETDESIGNATIONS: "Designation/getdesignations",
  CREATEDESIGNATION: "Designation/createdesignation",
  UPDATEDESIGNATION: "Designation/updatedesignation",
  DELETEDESIGNATION: "Designation/deletedesignation",

  GETALLSTAFFS: "Staff/getallstaffs",
  GETSTAFFS: "Staff/getstaffs",
  GETSTAFFSBYCOMPANY: "Staff/getstaffbycompany",
  SEARCHSTAFF: "Staff/searchstaff",
  CREATESTAFF: "Staff/createstaff",
  UPDATESTAFF: "Staff/updatestaff",
  DELETESTAFF: "Staff/deletestaff",

  GETALLATTENDANCE: "Attendance/getallattendances",
  GETTODAYATTENDANCE: "Attendance/gettodayattendance",
  GETATTENDANCESUMMARY: "Attendance/getattendancesummary",
  GETATTENDANCE: "Attendance/getattendance",
  GETATTENDANCEREPORT: "Attendance/getattendancereport",
  GETPAYOUTREPORT: "Attendance/getpayoutreport",
  STAFFCHECKIN: "Attendance/staffcheckin",
  STAFFCHECKOUT: "Attendance/staffcheckout",
  CREATEATTENDANCE: "Attendance/createattendance",
  UPDATEDATTENDANCE: "Attendance/updateattendance",
  DELETEATTENDANCE: "Attendance/deleteattendance",

  GETOVERTIME: "OverTime/getovertime",
  CREATEOVERTIME: "OverTime/createovertime",
  UPDATEOVERTIME: "OverTime/updateovertime",
  DELETEOVERTIME: "OverTime/deleteovertime",

  GETSTAFFSALARY: "Salary/getstaffsalaries",
  CREATESTAFFSALARY: "Salary/createstaffsalary",
  UPDATESTAFFSALARY: "Salary/updatestaffsalary",
  DELETESTAFFSALARY: "Salary/deletestaffsalary",

  GETCLIENTSERVICE: "ClientService/getclientservice",
  CREATECLIENTSERVICE: "ClientService/createclientservice",
  UPDATECLIENTSERVICE: "ClientService/updateclientservice",
  DELETECLIENTSERVICE: "ClientService/deleteclientservice",

  GETALLSERVICETASKS: "ServiceTask/getallservicetasks",
  GETTASKACCEPTEDBYSTAFF: "ServiceTask/gettaskacceptedbystaff",
  GETYOURSERVICETASK: "ServiceTask/getyourtasks",
  CREATESERVICETASK: "ServiceTask/createservicetask",
  CREATESERVICETASKBYSTAFF: "ServiceTask/taskcreatebystaff",
  UPDATESERVICETASK: "ServiceTask/updateservicetask",
  DELETESERVICETASK: "ServiceTask/deleteservicetask",
  ACCEPTSERVICETASK: "ServiceTask/accepttask",
  STATUSCOUNTS: "ServiceTask/statuscounts",
  SERVICETASKREPORT: "ServiceTask/servicetaskreport",
  GETSERVICETASKBYDOCUMENT: "ServiceTask/GetByDocument",

  GETDOCUMENT: "Document/getdocuments",
  GETDOCUMENTBYID: "Document/getdocument",
  CREATEDOCUMENT: "Document/createdocument",
  UPDATEDOCUMENT: "Document/updatedocument",
  DELETEDOCUMENT: "Document/deletedocument",

  GETALLPAYMENT: "Payment/getallpayments",
  GETPAYMENTS: "Payment/getpayments",
  GETPAYMENTREPORT: "Payment/paymentreport",
  CREATEPAYMENT: "Payment/createpayment",
  UPDATEPAYMENT: "Payment/updatePayment",
  PAYMENTUPDATEBYADMIN: "Payment/paymentupdatebyadmin",
  DELETEPAYMENT: "Payment/paymentdelete",
  PAYMENTORDERREQUEST: "Payments/Process",

  GETALLFOLDERS: "folder/getallfolders",
  GETFOLDERS: "Folder/getfolders",
  CREATEFOLDER: "Folder/createfolder",
  UPDATEFOLDER: "Folder/updatefolder",
  DELETEFOLDER: "Folder/deletefolder",
  SEARCHFOLDERS: "Folder/searchfolders",
  GETFOLDERBYCLIENT: "Folder/getfoldersbyClient",
  GETFOLDERSBYFOLDERID: "Folder/getfoldersbyfolderId",
  GETSERVICETASKBYFOLDERID: "Folder/getservicetaskbyFolderId",
  GETCLIENTIDBYFOLDERID: "Folder/getclientIdbyfolderId",
  GETFILESBYFOLDERID: "Document/GetDocumentsByFolderId",

  GETCOMMENTS: "ServiceTaskComment/getbyTask",
  CREATECOMMENT: "ServiceTaskComment/addcomment",

  GETALLCOMPANY: "Company/getallcompanies",
  GETCOMPANIES: "Company/getcompanies",
  CREATECOMPANY: "Company/createcompany",
  UPDATECOMPANY: "Company/updatecompany",
  DELETECOMPANY: "Company/deletecompany",
};
